import { getUserId, getLoginId } from '@/services/methods/user'
import { RequestConfig } from '@/services/http/types'
import http from '@/services/http'

/**
 * 查询企业风管期货商品信息
 */
export function queryErmcpGoods(config: RequestConfig<Model.GoodsReq> = {}) {
    return http.commonRequest<Model.GoodsRsp[]>({
        url: '/Ermcp/GetErmcpGoods',
        params: {
            loginid: getLoginId(),
            ...config.data
        },
    }, 'GetErmcpGoods')
}

/**
 * 获取商品盘面信息
 */
export function queryQuoteDay(config: RequestConfig<Model.QuoteDayReq> = {}) {
    return http.commonRequest<Model.QuoteDayRsp[]>({
        url: '/Quote/QueryQuoteDay',
        params: config.data,
    }, 'QueryQuoteDay')
}

/**
 * 查询采购列表
 */
export function queryTHJWrstandard(config: RequestConfig<Model.THJWrstandardReq> = {}) {
    return http.commonRequest<Model.THJWrstandardRsp[]>({
        url: '/Ferroalloy/QueryTHJWrstandard',
        params: config.data,
    })
}

/**
 * 查询采购详情
 */
export function queryTHJWrstandardDetail(config: RequestConfig<Model.THJWrstandardDetailReq> = {}) {
    return http.commonRequest<Model.THJWrstandardDetailRsp>({
        url: '/Ferroalloy/QueryTHJWrstandardDetail',
        params: config.data,
    })
}

/**
 * 查询供求列表
 */
export function queryTHJListing(config: RequestConfig<Model.THJListingReq> = {}) {
    return http.commonRequest<Model.THJListingRsp[]>({
        url: '/Ferroalloy/QueryTHJListing',
        params: config.data,
    })
}

/**
 * 查询大厅行情列表
 */
export function queryOrderQuote(config: RequestConfig<Model.OrderQuoteReq> = {}) {
    return http.commonRequest<Model.OrderQuoteRsp[]>({
        url: '/WrTrade2/QueryOrderQuote',
        params: config.data,
    })
}

/**
 * 查询买卖大厅
 */
export function queryOrderQuoteDetail(config: RequestConfig<Model.OrderQuoteDetailReq> = {}) {
    return http.commonRequest<Model.OrderQuoteDetailRsp[]>({
        url: '/WrTrade2/QueryOrderQuoteDetail',
        params: config.data,
    })
}

/**
 * 移除用户商品收藏信息
 */
export function removeUserFavoriteGoods(config: RequestConfig<Model.UserFavoriteGoodsReq> = {}) {
    return http.commonRequest<Model.UserFavoriteGoodsRsp[]>({
        method: 'post',
        url: '/User/RemoveUserFavoriteGoods',
        data: {
            userID: getUserId(),
            ...config.data
        },
    })
}

/**
 * 添加用户商品收藏信息
 */
export function addUserFavoriteGoods(config: RequestConfig<Model.UserFavoriteGoodsReq> = {}) {
    return http.commonRequest<Model.UserFavoriteGoodsRsp[]>({
        method: 'post',
        url: '/User/AddUserFavoriteGoods',
        data: {
            userID: getUserId(),
            ...config.data
        },
    })
}

/**
 * 获取我的推广-交易数据
 */
export function queryTHJTradeData(config: RequestConfig<Model.THJTradeDataReq> = {}) {
    return http.commonRequest<Model.THJTradeDataRsp[]>({
        url: '/Ferroalloy/QueryTHJTradeData',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 获取产品介绍列表
 */
export function queryTHJProduct(config: RequestConfig<Model.THJProductReq> = {}) {
    return http.commonRequest<Model.THJProductRsp[]>({
        url: '/Ferroalloy/QueryTHJProduct',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询市场交易参数配置
 */
export function queryWrMarketTradeConfig(config: RequestConfig<Model.WrMarketTradeConfigReq> = {}) {
    return http.commonRequest<Model.WrMarketTradeConfigRsp[]>({
        url: '/WrTrade2/QueryWrMarketTradeConfig',
        params: config.data,
    })
}

/**
 * 查询品种品类筛选框列表
 */
export function queryFtDeliveryGoods(config: RequestConfig = {}) {
    return http.commonRequest<Model.FtDeliveryGoodsRsp[]>({
        url: '/WrTrade2/QueryFtDeliveryGoods',
        params: config.data,
    })
}

/**
 * 查询品类要素定义项
 */
export function queryWrStandardFactoryItem(config: RequestConfig<Model.WrStandardFactoryItemReq> = {}) {
    return http.commonRequest<Model.WrStandardFactoryItemRsp[]>({
        url: '/WrTrade2/QueryWrStandardFactoryItem',
        params: config.data,
    })
}

/**
 * 查询企业风管期货商品信息
 */
export function queryTouristGoods(config: RequestConfig<{ trademodes?: string; marketids?: string; }> = {}) {
    return http.commonRequest<Model.GoodsRsp[]>({
        url: '/sbyj/GetTouristGoods',
        params: config.data,
    })
}

/**
 * 获取游客商品盘面信息
 */
export function queryTouristQuoteDay(config: RequestConfig<Model.QuoteDayReq> = {}) {
    return http.commonRequest<Model.QuoteDayRsp[]>({
        url: '/Quote/GetTouristQuoteDay',
        params: config.data,
    })
}

/**
 * 查询商品交割关系表
 */
export function queryDeliveryRelation(config: RequestConfig<Model.DeliveryRelationReq> = {}) {
    return http.commonRequest<Model.DeliveryRelationRsp[]>({
        url: '/Delivery/QueryDeliveryRelation',
        params: config.data,
    })
}

/**
 * 获取TCE商品集合表
 */
export function getTCEGoodsCollections(config: RequestConfig = {}) {
    return http.commonRequest<Model.TCEGoodsCollectionRsp[]>({
        url: '/Goods/GetTCEGoodsCollections',
        params: config.data,
    })
}